<div class="text-center" *ngIf="params">
    <i *ngIf="isPromoted" class="fa-solid fa-bullhorn fa-fw text-custom-success"></i>
    <i *ngIf="!isPromoted" class="fa-solid fa-bullhorn fa-fw text-custom-danger"></i>
</div>